// Elements
import { DetailSVG } from './Results.elements'

export function IconBell({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="18"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.125 14.25a.625.625 0 01.06 1.247L.875 15.5a.625.625 0 01-.06-1.247l16.31-.003zM10.25.5a.625.625 0 01.06 1.248l-.685.003v1.307c3.798.316 6.803 3.47 6.874 7.332l.001 1.985a.625.625 0 01-.565.622L2.125 13a.625.625 0 01-.622-.565L1.5 10.53c0-3.88 2.96-7.076 6.738-7.46l.137-.012V1.75H7.75A.625.625 0 017.69.503L10.25.5zM7.61 5.724C6.368 6.011 5.415 6.76 4.723 7.81a6.725 6.725 0 00-.72 1.462l-.118.363a4.021 4.021 0 00-.082.326.625.625 0 001.21.303l.059-.233.036-.122a5.49 5.49 0 01.659-1.411c.527-.8 1.224-1.348 2.123-1.556a.625.625 0 10-.282-1.218z"
        fill="#000"
        fillRule="nonzero"
      />
    </DetailSVG>
  )
}

export function IconCuisine({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="16"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 0C7.7598 0 7.97347 0.198242 7.99771 0.451837L8 0.5V4.5C8 5.30352 7.36505 5.96143 6.57051 5.99836L6.5 6H6V15.5C6 15.776 5.77604 16 5.5 16C5.2402 16 5.02653 15.8016 5.00229 15.5481L5 15.5V6H4.5C3.69648 6 3.03857 5.36505 3.00164 4.57051L3 4.5V0.5C3 0.223797 3.22396 0 3.5 0C3.7598 0 3.97347 0.198242 3.99771 0.451837L4 0.5V3H5V0.5C5 0.223797 5.22396 0 5.5 0C5.7598 0 5.97347 0.198242 5.99771 0.451837L6 0.5V3H7V0.5C7 0.223797 7.22396 0 7.5 0ZM12.4743 0.000813333C12.6117 -0.00683667 12.7454 0.04248 12.8454 0.13688C12.9325 0.219483 12.9868 0.330371 12.999 0.448829L13.0016 0.5V15.5C13.0016 15.776 12.7777 16 12.5016 16C12.2418 16 12.0282 15.8016 12.0039 15.5481L12.0016 15.5V9.75027L11.9769 9.7513C11.3587 9.7513 10.8649 9.56901 10.5098 9.20996C9.86469 8.55774 9.79731 7.47941 9.8015 6.21069L9.81011 5.22753L9.81087 5C9.81087 2.23356 10.9557 0.08431 12.4743 0.000813333Z"
        fill="#333333"
      />
    </DetailSVG>
  )
}

export function IconPin({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="14"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C3.134 0 0 3.174 0 7.09c0 2.868 3.758 9.104 5.767 12.232.271.422.735.678 1.232.678.498 0 .962-.255 1.234-.677C10.24 16.195 14 9.959 14 7.09 14 3.174 10.866 0 7 0zm0 9.972c-1.614 0-2.923-1.326-2.923-2.96 0-1.635 1.309-2.96 2.923-2.96s2.923 1.325 2.923 2.96c0 1.634-1.309 2.96-2.923 2.96z"
        fill="#006FCF"
        fillRule="nonzero"
      />
    </DetailSVG>
  )
}

export function IconTakeout({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="16"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.923 0c2.03 0 3.69 1.623 3.748 3.64l.002.11h1.25c.663 0 1.21.523 1.248 1.177l.002.073 1.25 13.75c0 .663-.523 1.21-1.177 1.248l-.073.002h-12.5c-.663 0-1.21-.523-1.248-1.177l-.002-.073L1.673 5c0-.663.523-1.21 1.177-1.248l.073-.002h1.25A3.754 3.754 0 017.923 0zM4.17 5H2.919l-.002.057-.003.056L1.673 18.75h12.5l-1.24-13.637-.005-.056L12.927 5h-1.251v1.25a.625.625 0 01-1.248.06l-.003-.06V5H5.42v1.25a.625.625 0 01-1.248.06l-.003-.06V5zm3.753-3.75a2.503 2.503 0 00-2.498 2.406l-.002.094h5c0-1.379-1.122-2.5-2.5-2.5z"
        fill="#000"
        fillRule="nonzero"
      />
    </DetailSVG>
  )
}

export function IconStar({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="25"
      height="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7501276,0.778239114 C11.2613932,-0.259413038 12.7386068,-0.259413038 13.2498724,0.778239114 L16.2026006,6.77102366 L22.8051014,7.73201135 C23.9483261,7.89840661 24.4048102,9.30564593 23.577565,10.1133455 L18.7999506,14.7780777 L19.9277924,21.3647853 C20.1230784,22.5052754 18.9279875,23.3749971 17.9054563,22.8365308 L12,19.7267093 L6.09454375,22.8365308 C5.07201251,23.3749971 3.87692156,22.5052754 4.07220765,21.3647853 L5.20004943,14.7780777 L0.422434965,10.1133455 C-0.404810182,9.30564593 0.051673941,7.89840661 1.19489862,7.73201135 L7.79739943,6.77102366 L10.7501276,0.778239114 Z M12,1.5 L8.75532156,8.08359214 L1.5,9.13932023 L6.75,14.263932 L5.51064312,21.5 L12,18.0835921 L18.4893569,21.5 L17.25,14.263932 L22.5,9.13932023 L15.2446784,8.08359214 L12,1.5 Z"
        id="Favorite"
        fill="#006FCF"
        fill-rule="nonzero"
      ></path>
    </DetailSVG>
  )
}

export function IconExternalLink({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="16"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14C12 14.5523 11.5523 15 11 15H2C1.44772 15 1 14.5523 1 14V5C1 4.44772 1.44772 4 2 4H4V2C4 1.44772 4.44772 1 5 1H14C14.5523 1 15 1.44772 15 2V11C15 11.5523 14.5523 12 14 12H12V14ZM14 2H5V11H14V2ZM11.5 4C11.7599 4 11.9735 4.1983 11.9977 4.45185L12 4.5V7.33333C12 7.60948 11.7761 7.83333 11.5 7.83333C11.2401 7.83333 11.0265 7.63504 11.0023 7.38149L11 7.33333V5.707L7.85355 8.85355C7.6705 9.03661 7.38081 9.04805 7.18442 8.88788L7.14645 8.85355C6.96339 8.6705 6.95195 8.38081 7.11212 8.18442L7.14645 8.14645L10.2927 5H8.66667C8.40677 5 8.19318 4.8017 8.16896 4.54815L8.16667 4.5C8.16667 4.2401 8.36496 4.02652 8.61851 4.00229L8.66667 4H11.5ZM5 12C4.44772 12 4 11.5523 4 11V5H2V14H11V12H5Z"
        fill="#333333"
      />
    </DetailSVG>
  )
}
export function IconTelephone({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="16"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00448 1.48195L6.0105 2.48781L6.15177 2.6269C6.27894 2.75189 6.4051 2.87601 6.5289 3.00178L6.71265 3.19197C7.37298 3.85266 7.3924 4.71269 6.76213 5.39404L6.70304 5.45548C6.39836 5.77409 6.07609 6.08603 5.76034 6.38916C5.94735 6.79313 6.21021 7.20149 6.57365 7.64928C7.34839 8.60691 8.20549 9.38878 9.12183 9.97355C9.198 10.0191 9.28308 10.0637 9.37369 10.1089L9.60881 10.2234C9.91707 9.90514 10.2361 9.58555 10.5551 9.26661C11.2 8.62059 12.1378 8.62059 12.7823 9.26628L13.3367 9.8175C13.7253 10.2032 14.1163 10.5912 14.5004 10.9857C14.8256 11.3109 15.0001 11.7015 15.0001 12.1103C15.0001 12.5189 14.8256 12.9095 14.4958 13.2395L14.352 13.3819L14.2074 13.5232C13.9724 13.7526 13.7504 13.9689 13.5512 14.1979C13.059 14.7404 12.4483 15 11.6768 15C11.6225 15 11.5675 14.9987 11.5118 14.9961C10.6381 14.9537 9.74715 14.696 8.70679 14.1849C6.88635 13.2962 5.29233 12.0673 3.96688 10.5309L3.82072 10.3589C2.73967 9.09688 1.93254 7.75613 1.42521 6.37825C1.09367 5.47991 0.964926 4.75962 1.00806 4.04274C1.04598 3.45161 1.28312 2.94454 1.71265 2.53308C1.83038 2.42025 1.94811 2.30402 2.06589 2.18665L2.60425 1.65032C2.66452 1.5911 2.7248 1.53245 2.78508 1.47462C3.41496 0.844237 4.35962 0.836907 5.00448 1.48195ZM3.89103 1.98968C3.73941 1.98968 3.60824 2.07565 3.51695 2.15894L3.48462 2.18987C3.30135 2.36579 3.12557 2.54171 2.94979 2.71763C2.76799 2.89974 2.58602 3.08169 2.40422 3.25598C2.15438 3.49527 2.02791 3.76485 2.0061 4.10496C1.97192 4.67459 2.08211 5.26946 2.36353 6.03178C2.81255 7.25179 3.49043 8.39904 4.43261 9.53273L4.58358 9.71162C5.85034 11.2245 7.38436 12.4257 9.14624 13.2857C10.0613 13.7353 10.8276 13.9611 11.5593 13.9966C11.5981 13.9982 11.6378 13.9992 11.6768 13.9992C12.1638 13.9992 12.5111 13.8555 12.8038 13.5333C12.9791 13.3316 13.1724 13.1368 13.3653 12.9475L13.5095 12.8065C13.6029 12.7153 13.6964 12.6241 13.7888 12.5319C13.8852 12.4355 14.0001 12.284 14.0001 12.1103C14.0001 11.9364 13.8852 11.7852 13.7888 11.6888C13.4041 11.2936 13.017 10.9098 12.6326 10.5284L12.0753 9.97388C11.9841 9.88266 11.8396 9.77385 11.669 9.77385C11.4981 9.77385 11.3536 9.88266 11.2625 9.97388C11.0257 10.2108 10.7889 10.4478 10.5566 10.6846L10.212 11.0398C10.1456 11.1066 9.96427 11.2887 9.67521 11.2887C9.5603 11.2887 9.44735 11.2601 9.32951 11.2011L9.22791 11.1508L9.12703 11.1021C8.95288 11.018 8.77319 10.931 8.59546 10.8245C7.57674 10.1746 6.63908 9.32069 5.79696 8.27966C5.33146 7.70613 5.00545 7.1795 4.77124 6.62324C4.65015 6.30039 4.71053 6.0194 4.93823 5.79168C5.2041 5.5366 5.47235 5.27932 5.73206 5.01811L5.98853 4.75554C6.09741 4.64641 6.21834 4.48954 6.21834 4.31884C6.21834 4.1652 6.12039 4.02278 6.02688 3.92185L5.99601 3.88978C5.87405 3.76099 5.75339 3.63951 5.63254 3.5198L5.45093 3.34085C5.3549 3.24637 5.25822 3.15141 5.16154 3.05465L4.29745 2.18971C4.2063 2.09849 4.06161 1.98968 3.89103 1.98968Z"
        fill="#333333"
      />
    </DetailSVG>
  )
}

export function IconSpecialOffer({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.4008 0.0818742L6.45433 0.106938L6.50637 0.135343L10.7432 2.62085C11.0393 2.7947 11.2292 3.11079 11.2484 3.45554L11.25 3.51325V8.48437C11.25 8.83208 11.0757 9.15721 10.7913 9.3464L10.7429 9.37665L6.50637 11.8623C6.35245 11.9524 6.17742 12 6 12C5.84475 12 5.69135 11.9635 5.55246 11.8941L5.49387 11.8623L1.25685 9.37665C0.960661 9.20291 0.770771 8.88694 0.751603 8.5421L0.75 8.48437V3.51325C0.75 3.16566 0.924299 2.84042 1.20838 2.65112L1.25673 2.62085L5.49363 0.135343C5.76685 -0.0250635 6.11167 -0.0428865 6.4008 0.0818742ZM7.05065 4.69276L6.31247 3.19456C6.18998 2.94596 5.8457 2.9356 5.70473 3.16348L5.68753 3.19456L4.94935 4.69276L3.29872 4.933C3.02391 4.973 2.90783 5.29981 3.08316 5.5044L3.10561 5.52834L4.30001 6.69452L4.01805 8.3412C3.97097 8.61614 4.24711 8.82813 4.4961 8.72222L4.52364 8.70913L6 7.93168L7.47636 8.70913C7.72287 8.83894 8.00948 8.6414 7.98587 8.37147L7.98195 8.3412L7.69999 6.69452L8.89439 5.52834C9.09325 5.33418 8.99539 5.00144 8.73348 4.93915L8.70128 4.933L7.05065 4.69276Z"
        fill="grey"
      />
    </DetailSVG>
  )
}

export function IconSpecialOfferTitle({ className }) {
  return (
    <DetailSVG
      className={`${className}`}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66801 0.136457L9.75722 0.17823L9.84395 0.225572L16.9053 4.36808C17.3989 4.65783 17.7154 5.18464 17.7473 5.75923L17.75 5.85541V14.1406C17.75 14.7201 17.4595 15.262 16.9855 15.5773L16.9048 15.6277L9.84395 19.7705C9.58741 19.9206 9.2957 20 9 20C8.74126 20 8.48558 19.9392 8.25411 19.8234L8.15645 19.7705L1.09475 15.6277C0.601101 15.3382 0.284618 14.8116 0.252671 14.2368L0.25 14.1406V5.85541C0.25 5.27609 0.540498 4.73404 1.01396 4.41853L1.09455 4.36808L8.15605 0.225572C8.61141 -0.0417726 9.18612 -0.0714775 9.66801 0.136457ZM10.7511 7.82126L9.52078 5.32427C9.31663 4.90993 8.74284 4.89266 8.50789 5.27247L8.47922 5.32427L7.24892 7.82126L4.49787 8.22167C4.03985 8.28834 3.84638 8.83301 4.1386 9.174L4.17601 9.21389L6.16669 11.1575L5.69675 13.902C5.61829 14.3602 6.07851 14.7136 6.4935 14.537L6.53939 14.5152L9 13.2195L11.4606 14.5152C11.8714 14.7316 12.3491 14.4023 12.3098 13.9525L12.3032 13.902L11.8333 11.1575L13.824 9.21389C14.1554 8.8903 13.9923 8.33574 13.5558 8.23192L13.5021 8.22167L10.7511 7.82126Z"
        fill="#333333"
      />
    </DetailSVG>
  )
}

export function IconSearch({ className }) {
  return (
    <DetailSVG
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5669 17.6831L13.4059 12.5222C15.6598 9.82114 15.522 5.79931 12.9864 3.26365C11.6439 1.92121 9.88446 1.25 8.12499 1.25C6.36553 1.25 4.60606 1.92121 3.26365 3.26365C0.578785 5.94849 0.578785 10.3015 3.26365 12.9863C4.60606 14.3288 6.36553 15 8.12499 15C9.68892 15 11.2511 14.4666 12.5221 13.4059L17.6831 18.5669C17.8052 18.689 17.9651 18.75 18.125 18.75C18.2849 18.75 18.4448 18.689 18.5669 18.5669C18.811 18.323 18.811 17.927 18.5669 17.6831ZM4.14754 12.1025C3.08509 11.0401 2.49999 9.62748 2.49999 8.125C2.49999 6.62252 3.08509 5.20994 4.14754 4.14752C5.20995 3.0851 6.62251 2.5 8.12499 2.5C9.6275 2.5 11.0401 3.0851 12.1025 4.14752C13.1649 5.20994 13.75 6.62252 13.75 8.125C13.75 9.62748 13.1649 11.0401 12.1025 12.1025C11.0401 13.1649 9.6275 13.75 8.12499 13.75C6.62251 13.75 5.20995 13.1649 4.14754 12.1025Z"
        fill="#53565A"
      />
    </DetailSVG>
  )
}

export function IconChevronRight({ className }) {
  return (
    <svg
      className={className}
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L8.5 9L1 17"
        stroke="#006FCF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function IconChevronDown({ className }) {
  return (
    <svg
      className={className}
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.5L9 9L17 1.5"
        stroke="#006FCF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function IconSortNearest({ className }) {
  return (
    <DetailSVG
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.09312 14.9668H6.26385C6.46583 14.9668 6.6297 14.7284 6.6297 14.4346C6.6297 14.1581 6.48454 13.9307 6.29907 13.9049L6.26385 13.9025H3.09312C2.89114 13.9025 2.72726 14.1409 2.72726 14.4346C2.72726 14.7112 2.87243 14.9386 3.0579 14.9644L3.09312 14.9668Z"
        fill="#53565A"
      />
      <path
        d="M3.08837 6.45239H9.10674C9.3061 6.45239 9.46784 6.21421 9.46784 5.92024C9.46784 5.64357 9.32457 5.41631 9.1415 5.39053L9.10674 5.38809H3.08837C2.88901 5.38809 2.72726 5.62628 2.72726 5.92024C2.72726 6.19691 2.87054 6.42418 3.0536 6.44996L3.08837 6.45239Z"
        fill="#53565A"
      />
      <path
        d="M3.09137 10.7096H6.97513C7.17615 10.7096 7.33924 10.4714 7.33924 10.1774C7.33924 9.90077 7.19477 9.67351 7.01019 9.64773L6.97513 9.64529H3.09137C2.89035 9.64529 2.72726 9.88348 2.72726 10.1774C2.72726 10.4541 2.87173 10.6814 3.05631 10.7072L3.09137 10.7096Z"
        fill="#53565A"
      />
      <path
        d="M10.3332 12.1116C10.1385 12.3066 10.1261 12.615 10.2968 12.824L13.389 15.9118C13.5841 16.0708 13.8658 16.0708 14.0611 15.9118L17.1167 12.8644C17.2207 12.7604 17.2727 12.6241 17.2727 12.4879C17.2727 12.3517 17.2207 12.2155 17.1168 12.1116C16.9219 11.9166 16.6134 11.9045 16.404 12.0749L14.2577 14.2143V4.50125C14.2577 4.20723 14.0193 3.96899 13.725 3.96899C13.4481 3.96899 13.2206 4.18003 13.1948 4.44998L13.1924 14.2143L11.0866 12.1114C10.8783 11.9037 10.5411 11.9037 10.3332 12.1116Z"
        fill="#53565A"
      />
    </DetailSVG>
  )
}
